import { render, staticRenderFns } from "./MyAccountOld.vue?vue&type=template&id=ae2fe56c&scoped=true"
import script from "./MyAccountOld.vue?vue&type=script&lang=js"
export * from "./MyAccountOld.vue?vue&type=script&lang=js"
import style0 from "./MyAccountOld.vue?vue&type=style&index=0&id=ae2fe56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2fe56c",
  null
  
)

export default component.exports